module.exports = __webpack_public_path__ + "static/media/trig.fce618e2.svg";